import { Box, Button, Checkbox, CircularProgress, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, IconButton, Menu } from "@mui/material";
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { personalTrainerSchema } from '../../../schemas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import TablePaginationActions from '../../../base-components/TablePaginationActions';
import CustomModal from '../../../base-components/CustomModal';
import Popup from '../../../base-components/Popup';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import dayjs from 'dayjs';
import PersonalTrainerStatsModal from './StatsModal';
import TrainerMemberLogTable from './TrainerMemberLogTable';
import BarChartIcon from '@mui/icons-material/BarChart';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getSessionUser, hasPermission, isDynamicStaffRole } from '../../../utils/roleAccess';
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;
function PersonalTrainers() {
    const navigate = useNavigate()
    const [trainers , setTrainers] = useState([])
    const [trainer , setTrainer] = useState({})
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [trainerLogs, setTrainerLogs] = useState([]);
    const [loadingTrainerLogs, setLoadingTrainerLogs] = useState(false);

    const [trainerToDelete , setTrainerToDelete] = useState('')
    const [trainerToUpdate , setTrainerToUpdate] = useState('')
    const [isAddModalOpen , setIsAddModalOpen] = useState(false)
    const [isViewModalOpen , setIsViewModalOpen] = useState(false)
    const [isDeleteModalOpen , setIsDeleteModalOpen] = useState(false)
    const [isUpdateModalOpen , setIsUpdateModalOpen] = useState(false)
    const [isMemberModalOpen , setIsMemberModalOpen] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page , setPage ] = useState(0)
    const [isSuccessAlert , setIsSuccessAlert] = useState(false)
    const [isFaliureAlert , setIsFailureAlert] = useState(false)
    const [successMessage , setSuccessMessage] = useState('')
    const [failureMessage , setFailureMessage] = useState('')
    const [isPopupOpen , setIsPopupOpen] = useState(false)
    const [loading , setLoading] = useState(false)
    const [loadingMembers , setLoadingMembers] = useState(false)
    const [role , setRole] = useState('')
    const [locations , setLocations] = useState([])
    const [location , setLocation] = useState()
    const [location_id , setLocationId] = useState('')
    const [company_id , setCompanyID] = useState('')
    const [user_id, setUserId] = useState('')
     const [members, setMembers] = useState([]);
    const [showPassword , setShowPassword] = useState(false)
    const [assignableRoles, setAssignableRoles] = useState([])
    const [totalMembersCount , setTotalMembersCount] = useState(0)
    const [totalFees , setTotalFees] = useState(0)
    const [totalTrainers , setTotalTrainers] = useState(0)
    const [buttonLoading, setButtonLoading] = useState(false);

    // State and method for Stats Modal
    const [isStatsModalOpen, setIsStatsModalOpen] = useState(false);
    const handleOpenStatsModal = () => {
        setIsStatsModalOpen(true);
    };

    // Anchor state for the actions menu
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedTrainer, setSelectedTrainer] = useState(null);
    const openAnchor = Boolean(anchorEl);
    const handleClickAnchor = (event, trainerId) => {
      setAnchorEl(event.currentTarget);
      setSelectedTrainer(trainerId);
    };
    const handleCloseAnchor = () => {
      setAnchorEl(null);
      setSelectedTrainer(null);
    };

    useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
          const session = JSON.parse(sessionStr);
          setRole(session.user.role)
          setCompanyID(session.user.company_id)
          setLocationId(session.user.location_id)
          setUserId(session.user._id)
        }
         else {
          navigate('/login');
        }
  },[])

  useEffect(() => {
    if (user_id) {
      loadAssignableRoles();
    }
  }, [user_id]);

  const loadAssignableRoles = () => {
    if (!user_id) return;
    fetch(`${BASE_URL}company-staff-access/assignable-roles?actingUserId=${user_id}`)
      .then((response) => response.json())
      .then((data) => {
        setAssignableRoles(data.roles || []);
      })
      .catch((error) => {
        console.error("Error fetching assignable roles:", error);
        setAssignableRoles([]);
      });
  };

//     useEffect(() => {
//         if(role) {
//             setLoading(true)
//             getTrainers()
//             getLocations()
//             setTimeout(()=> {
//             setLoading(false)
//             } , 1000)
//         }
// }, [role]);

useEffect(() => {
  const fetchTrainer = async () => {
    setLoading(true);
    if (role) {
      await getTrainers(); 
      await getLocations(); 
    }
    setLoading(false);
  };

  fetchTrainer();
}, [role]);

    async function getLocations () {
        if(!role) return;

        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = 'locations/getLocations';
        } else if (role === 'Admin') {
            endpoint = `locations/getLocationsByCompanyID/${company_id}`;
        }
        
        await fetch(BASE_URL + endpoint)
            .then((response) => response.json())
            .then((data) => {
                setLocations(data.locations)
            })
            .catch((error) => {
                console.log(error)
            } );
    }
    async function getTrainers () {
          if(!role) return;
          setLoading(true)
          let endpoint = '';
          console.log(role);
          if (role === 'SuperAdmin') {
              endpoint = `trainers/get-trainers`;
          } else if (role === 'Admin' ) {
              endpoint = `trainers/get-trainers-by-company/${company_id}`;
          } else if(role === 'ClubAdmin') {
            endpoint = `trainers/get-trainers-by-location/${location_id}`;
          } else if (isDynamicStaffRole(role)) {
            endpoint = `trainers/get-trainers-by-location/${location_id}`;
          }
        await fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            setTrainers(data.trainers)
            setTotalMembersCount(data.totalMembersCount)
            setTotalFees(data.totalFees)
            setTotalTrainers(data.trainers?.length)
            setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          setLoading(false)
      });
    }
  
    async function getTrainerByID (id) {
       await fetch(BASE_URL + `trainers/get-trainer/${id}`)
        .then((response) => response.json())
        .then((data) => {
            setTrainer(data.trainer)
            console.log(data.trainer,"train data")
            setValues({
                company_id: data.trainer.company_id,
                location_id: data.trainer.location_id._id,
                name: data.trainer.name,
                email:  data.trainer.email,
                phone_number:  data.trainer.phone_number,
                address:  data.trainer.address,
                experience_years: data.trainer.experience_years,
                monthly_rate: data.trainer.monthly_rate,
                availability: data.trainer.availability,
                hire_date: data.trainer.hire_date,
                employment_status: data.trainer.employment_status,
                password: '',
                role: data.trainer.portal_access?.role || 'Trainer',
            });
        })
        .catch((error) => console.log(error));
    }

    const handleAddTrainer = async (values, actions) => {
        setButtonLoading(true);
        values.company_id = company_id;
        if(role === 'ClubAdmin'){
          values.location_id = location_id;
        } else if (isDynamicStaffRole(role)) {
          values.location_id = location_id;
        }
        values.actingUserId = user_id;

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            };
    
            try {
                const response = await fetch(BASE_URL + `trainers/create-trainer`, requestOptions);
    
                console.log('Response status:', response.status);
                if (!response.ok) {
                    const responseData = await response.json();
                    console.error('Response not ok:', responseData);
                    setIsFailureAlert(true)
                    setFailureMessage(responseData.message)
                    setIsPopupOpen(true)
                    setTimeout(() => {
                        setIsPopupOpen(false)
                    }, 5000)
                } else {
                    const responseData = await response.json();
                    console.log('Response data:', responseData);
                    setIsAddModalOpen(false)
                    actions.resetForm()
                    getTrainers()
                    setIsSuccessAlert(true)
                    setSuccessMessage('Trainer added Successfully')
                    setIsPopupOpen(true)
                    setTimeout(() => {
                        setIsPopupOpen(false)
                    } , 5000)
                }
            } catch (error) {
                console.error('Caught error:', error);
                setIsFailureAlert(true) 
                setFailureMessage('Failed to add Trainer')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                } , 5000)
            } finally {
              setButtonLoading(false);
                // setLoading(false);
            }
    
    }
  
    const handleUpdateTrainer = async (values, actions) => {
        setButtonLoading(true);
        values.company_id = company_id;
        if(role === 'ClubAdmin'){
          values.location_id = location_id;
        } else if (isDynamicStaffRole(role)) {
          values.location_id = location_id;
        }
        values.actingUserId = user_id;
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
        };
  
        try {
            const response = await fetch(BASE_URL + `trainers/update-trainer/${trainerToUpdate}`, requestOptions);
  
            console.log('Response status:', response.status);
            if (!response.ok) {
                console.error('Response not ok:', response);
                setIsFailureAlert(true)
                setFailureMessage('Failed to Update Trainer')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 5000)
            } else {
                const responseData = await response.json();
                console.log('Response data:', responseData);
                actions.resetForm()
                setIsUpdateModalOpen(false)
                getTrainers()
                setIsSuccessAlert(true)
                setSuccessMessage('Trainer Updated Successfully')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 5000)
            }
        } catch (error) {
            console.error('Caught error:', error);
            setIsFailureAlert(true)
            setFailureMessage('Failed to Update Trainer')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        } finally {
          setButtonLoading(false);
            // setLoading(false);
        }
  }
  
    function deleteTrainer () {
        setButtonLoading(true);
        const requestOptions = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        };
        fetch(BASE_URL + `trainers/delete-trainer/${trainerToDelete}` , requestOptions)
        .then((response) => response.json())
        .then((data) => {
            getTrainers()
            setIsDeleteModalOpen(false)
            setIsSuccessAlert(true)
            setSuccessMessage('Trainer deleted Successfully')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        })
        .catch((error) => {
            console.log(error)
            setIsFailureAlert(true)
            setFailureMessage('Failed to delete Trainer')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        }).finally(() => {
          setButtonLoading(false);
        });
    }
  
  
    function toggleAddModal() {
        setIsAddModalOpen(!isAddModalOpen)
        resetForm()
    }
    function toggleViewModal() {
        setIsViewModalOpen(!isViewModalOpen)
        resetForm()
    }
  
    function toggleUpdateModal() {
        setIsUpdateModalOpen(!isUpdateModalOpen)
        resetForm()
    }
    function toggleDeleteModal() {
        setIsDeleteModalOpen(!isDeleteModalOpen)
    }
    function toggleMemberModal() {
      setIsMemberModalOpen(!isMemberModalOpen)
  }
  
    function showAddModal(id) {
        loadAssignableRoles();
        setIsAddModalOpen(true);
    }
    async function fetchTrainerMemberLogs(id) {
        setLoadingTrainerLogs(true);
        try {
            const response = await fetch(BASE_URL + `trainers/get-trainer-member-logs/${id}`);
            const data = await response.json();
            if (response.ok && data.logs) {
                setTrainerLogs(data.logs);
            } else {
                setTrainerLogs([]);
            }
        } catch (error) {
            console.log(error);
            setTrainerLogs([]);
        } finally {
            setLoadingTrainerLogs(false);
        }
    }

    function showViewModal(id) {
        getTrainerByID(id);
        fetchTrainerMemberLogs(id);
        setIsViewModalOpen(true);
    }
    function showMemberModal(id){
      getTrainerByID(id);
        setIsMemberModalOpen(true)
    }

    function showUpdateModal(id) {
        loadAssignableRoles();
        getTrainerByID(id);
        setTrainerToUpdate(id);
        setIsUpdateModalOpen(true);
    }
    function showDeleteModal(id) {
        setTrainerToDelete(id);
        setIsDeleteModalOpen(true);
    }
    const handleViewMembers = async (trainerRow) => {
      setTrainer(trainerRow);
      setLoadingMembers(true);
      await Promise.all([
        getTrainerMembers(trainerRow._id),
        fetchTrainerMemberLogs(trainerRow._id),
      ]);
      setLoadingMembers(false);
      setIsMemberModalOpen(true);
  };

  const getTrainerMembers = async(id) => {
    await fetch(BASE_URL + `members/getMembersByTrainerID/${id}`)
    .then((response) => response.json())
    .then((data) => {
      if(data.members) {
        setFilteredMembers(data.members)
      }else {
        setFilteredMembers([])
      }
    })
    .catch((error) => console.log(error));
  }
  
    const paginatedTrainers = !trainers || trainers.length === 0 ? [] :
    rowsPerPage === -1
    ? trainers // Show all if "All" option is selected
    : trainers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
  
      const {values , touched , errors , handleBlur , handleChange , handleSubmit , setValues , resetForm , setFieldValue} = useFormik({
            enableReinitialize: true, 
            initialValues: {
            company_id: '',
            location_id: '',
            name: '',
            email: '',
            password: '',
            role: 'Trainer',
            phone_number: '',
            address: '',
            experience_years: '',
            monthly_rate: '',
            availability: [],
            hire_date: '',
            employment_status: '',
        },
        validationSchema: personalTrainerSchema(isUpdateModalOpen , location_id ? true : false ),
        onSubmit: (values, actions) => {
            console.log('Formik Errors:', errors); 
            if(isAddModalOpen){
                handleAddTrainer(values, actions); // Call the external function
            } else if(isUpdateModalOpen) {
                handleUpdateTrainer(values, actions);
            }
        },
    })
  return (
    <>
        <div className="m-5">
          <PageHeader
            title="Personal Trainers"
            actions={
                  hasPermission(getSessionUser(), 'trainers:create') ? (
                  <button className='gx-cta' onClick={showAddModal}>Add Trainer</button>
                  ) : null
            }
          />
        </div>
        <div className='flex mx-5'>
          <Button         
            variant="contained"
            color="primary"
            startIcon={<BarChartIcon />}
            className="bg-gx-red hover:bg-[#ff0008] text-white font-bold rounded-lg relative overflow-hidden" 
            onClick={handleOpenStatsModal}
          > 
            View Stats 
          </Button>
        </div>
        {
         loading ? (
            
              <div className="flex justify-center items-center mt-20 relative">
                {/* SVG Gradient Definition */}
                <svg width="0" height="0">
                  <defs>
                    <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#D71920" />
                      <stop offset="100%" stopColor="#F7931E" />
                    </linearGradient>
                  </defs>
                </svg>
        
                {/* Circular Progress with Gradient Stroke */}
                <CircularProgress
                  thickness={4}
                  size={35}
                  sx={{
                    'svg circle': {
                      stroke: 'url(#gradientColors)', // Apply gradient stroke
                    },
                  }}
                />
              </div>
            
          ) : (
            trainers && trainers.length !== 0 ? (     
            <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-auto ">
                <Table>
                  <TableHead>
                      <TableRow >
                          <TableCell>Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Access Role</TableCell>
                          <TableCell>Phone</TableCell>
                          <TableCell>Experience</TableCell>
                          <TableCell>Hire Date</TableCell>
                          <TableCell>No of Member</TableCell>
                          <TableCell>Trainer Fee</TableCell>
                          <TableCell>Total Revenue </TableCell>
                          <TableCell>Actions</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      paginatedTrainers?.map((trainer , index) => (
                        <TableRow hover key={index}>
                            <TableCell>{trainer.name}</TableCell>
                            <TableCell>{trainer.email}</TableCell>
                            <TableCell>{trainer.portal_access?.role || 'Trainer'}</TableCell>
                            <TableCell>{trainer.phone_number}</TableCell>
                            <TableCell>{trainer.experience_years} Years</TableCell>
                            <TableCell> {trainer?.hire_date 
    ? dayjs(trainer.hire_date).format("MMM DD, YYYY") 
    : ''}
</TableCell>

{/* <TableCell>
    <button 
        className='text-blue-600 hover:text-blue-800 font-medium'
        onClick={() => handleViewMembers(trainer._id)}
    >
        View Members 
    </button>
</TableCell> */}
<TableCell>
    <button 
        className='text-[#353535] hover:text-blue-800 font-medium text-xl'
        onClick={() => handleViewMembers(trainer)}
    >
        {trainer?.membersCount || 0}
    </button>
</TableCell>
                            <TableCell>{trainer.monthly_rate}</TableCell>
                            <TableCell>{trainer.monthly_rate}</TableCell>
                            <TableCell>
                            <Tooltip title="Actions">
                      <IconButton onClick={(event) => handleClickAnchor(event, trainer._id)}>
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>
                    <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showViewModal(selectedTrainer);
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} className='mr-2'/> View 
                      </MenuItem>
                      {hasPermission(getSessionUser(), 'trainers:update') && (
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showUpdateModal(selectedTrainer);
                        }}
                      >
                        <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                      </MenuItem>
                      )}
                      {hasPermission(getSessionUser(), 'trainers:delete') && (
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showDeleteModal(selectedTrainer);
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                      </MenuItem>
                      )}
                    </Menu>
                            </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                  <TableFooter>
                      <TableRow>
                      <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={12}
                          count= {trainers.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          slotProps={{
                              select: {
                              inputProps: {
                                  'aria-label': 'rows per page',
                              },
                              native: true,
                              },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                          />
                      </TableRow>
                  </TableFooter>
              </Table>
            </Box>
            ) : (
              <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
              </div>
            )
          )
          }
  
  <CustomModal
  isModal={isAddModalOpen || isUpdateModalOpen}
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }}
  size='2xl'
>
  <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>
    {isAddModalOpen ? 'Add Trainer' : 'Update Trainer'}
  </h1>
  <form onSubmit={handleSubmit} className='text-gx-ink-soft m-5' autoComplete='off'>
    <div>
      <input type='hidden' value={values.company_id} />
    </div>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5'>
      <div className='w-full'>
        <label>Name <span className='text-red-600'>*</span></label>
        <input
          type='text'
          name='name'
          placeholder='Enter Name'
          value={values.name}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.name && touched.name ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.name && errors.name && <p className='text-red-500 pl-2 italic'>{errors.name}</p>}
      </div>
      <div className='w-full'>
        <label>Email <span className='text-red-600'>*</span></label>
        <input
          type='email'
          name='email'
          placeholder='Enter Email'
          value={values.email}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.email && touched.email ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && errors.email && <p className='text-red-500 pl-2 italic'>{errors.email}</p>}
      </div>
    </div>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5'>
      {(isAddModalOpen || isUpdateModalOpen) && (
        <div className='w-full'>
          <label>
            {isUpdateModalOpen ? 'New Password (optional)' : 'Password'}
            {isAddModalOpen && <span className='text-red-600'> *</span>}
          </label>
          <input
            type={showPassword ? 'text' : 'password'}
            name='password'
            placeholder={isUpdateModalOpen ? 'Leave blank to keep current' : 'Enter Password'}
            value={values.password}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.password && touched.password ? 'border-red-600' : ''}`}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <button
            type='button'
            className='w-full flex justify-end pr-10 -mt-7 text-gx-ink-soft'
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
          </button>
          {touched.password && errors.password && <p className='text-red-500 pl-2 mt-3 italic'>{errors.password}</p>}
        </div>
      )}
      <div className='w-full'>
        <label>Access Role</label>
        <select
          name='role'
          value={values.role || 'Trainer'}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.role && touched.role ? 'border-red-600' : ''}`}
        >
          {assignableRoles.length === 0 && (
            <option value='Trainer'>Trainer</option>
          )}
          {assignableRoles.map((r) => (
            <option key={r._id} value={r.name}>{r.name}</option>
          ))}
        </select>
        {touched.role && errors.role && <p className='text-red-500 pl-2 italic'>{errors.role}</p>}
      </div>
    </div>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5'>
      <div className='w-full'>
        <label>Phone  <span className='text-red-600'>*</span></label>
        <input
          type='text'
          name='phone_number'
          placeholder='Enter Phone'
          value={values.phone_number}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.phone_number && touched.phone_number ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.phone_number && errors.phone_number && <p className='text-red-500 pl-2 italic'>{errors.phone_number}</p>}
      </div>
      <div className='w-full'>
        <label>Experience  <span className='text-red-600'>*</span></label>
        <input
          type='text'
          name='experience_years'
          placeholder='Enter Experience in Years'
          value={values.experience_years}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.experience_years && touched.experience_years ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.experience_years && errors.experience_years && <p className='text-red-500 pl-2 italic'>{errors.experience_years}</p>}
      </div>
    </div>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5'>
      <div className='w-full'>
        <label>Hire Date  <span className='text-red-600'>*</span></label>
        <input
          type='date'
          name='hire_date'
          placeholder='Hire Date'
          value={dayjs(values.hire_date).format("YYYY-MM-DD")}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.hire_date && touched.hire_date ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.hire_date && errors.hire_date && <p className='text-red-500 pl-2 italic'>{errors.hire_date}</p>}
      </div>
      <div className='w-full'>
        <FormControl fullWidth error={touched.availability && Boolean(errors.availability)}>
          <label>Available Days  <span className='text-red-600'>*</span></label>
          <Select
            name='availability'
            label='Available Days'
            value={values.availability}
            onChange={handleChange}
            onBlur={handleBlur}
            multiple
            className='w-full max-w-[320px] h-10 bg-gx-canvas p-2 rounded-xl outline-0'
            input={<OutlinedInput label='Available Days' />}
          >
            <MenuItem value='Mon'>Monday</MenuItem>
            <MenuItem value='Tue'>Tuesday</MenuItem>
            <MenuItem value='Wed'>Wednesday</MenuItem>
            <MenuItem value='Thurs'>Thursday</MenuItem>
            <MenuItem value='Fri'>Friday</MenuItem>
            <MenuItem value='Sat'>Saturday</MenuItem>
            <MenuItem value='Sun'>Sunday</MenuItem>
          </Select>
          {touched.availability && errors.availability && <FormHelperText>{errors.availability}</FormHelperText>}
        </FormControl>
      </div>
    </div>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5'>
      <div className='w-full'>
        <label>Monthly Fee  <span className='text-red-600'>*</span></label>
        <input
          type='number'
          name='monthly_rate'
          placeholder='Enter Monthly Fee'
          value={values.monthly_rate}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.monthly_rate && touched.monthly_rate ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.monthly_rate && errors.monthly_rate && <p className='text-red-500 pl-2 italic'>{errors.monthly_rate}</p>}
      </div>
      <div className='w-full'>
        <label>Employment Status  <span className='text-red-600'>*</span></label>
        <select
          name='employment_status'
          placeholder='Enter Employment Status'
          value={values.employment_status}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.employment_status && touched.employment_status ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option>Select Employment Status</option>
          <option value='part-time'>Part Time</option>
          <option value='full-time'>Full Time</option>
        </select>
        {touched.employment_status && errors.employment_status && <p className='text-red-500 pl-2 italic'>{errors.employment_status}</p>}
      </div>
    </div>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5'>
      {role === 'SuperAdmin' || role === 'Admin' ? (
        <div className='w-full'>
          <label>Location  <span className='text-red-600'>*</span></label>
          <select
            name='location_id'
            placeholder='Enter Location'
            value={values.location_id}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.location_id && touched.location_id ? 'border-red-600' : ''}`}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="" disabled>Locations</option>
            {locations?.map((location, index) => (
              <option key={index} value={location._id}>{location.name}</option>
            ))}
          </select>
          {touched.location_id && errors.location_id && <p className='text-red-500 pl-2 italic'>{errors.location_id}</p>}
        </div>
      ) : null}
      <div className='w-full'>
        <label>Address <span className='text-red-600'>*</span></label>
        <input
          type='text'
          name='address'
          placeholder='Enter Address'
          value={values.address}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.address && touched.address ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.address && errors.address && <p className='text-red-500 pl-2 italic'>{errors.address}</p>}
      </div>
    </div>
    <div className="flex justify-end items-center pt-3 mt-3 border-t">
      <button type='submit' 
        className={`bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
        disabled={buttonLoading}
      >
        {buttonLoading ? "Submitting..." : "Submit"}
        {buttonLoading && (
          <CircularProgress
            size={20}
            className="ml-2 mt-1"
            sx={{ color: "white" }}
          />
        )}
      </button>
    </div>
  </form>
</CustomModal>

      
<CustomModal isModal={isViewModalOpen} handleModal={toggleViewModal} size='2xl'>
  
    <div className="p-4 sm:p-8 md:p-10 lg:p-12">
      <Tooltip title="" placement="bottom">
        <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
          View Trainer
        </h1>
        <div className="overflow-x-auto mt-6">
          <Box>
            <Table className="min-w-full">
              <TableBody>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Name</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Email</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Address</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.address}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Experience</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.experience_years}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Fee</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.monthly_rate}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Location</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.location_id?._id}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Phone No</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.phone_number}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Employment Status</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">{trainer.employment_status}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">Hire Date</TableCell>
                  <TableCell className="px-3 py-2 sm:px-5 sm:py-3">
                    {trainer?.hire_date
                      ? dayjs(trainer.hire_date).format('MMM DD, YYYY')
                      : ''}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
          <h2 className="text-lg font-medium mt-8 mb-2 text-gx-ink-soft">
            Member assignment history
          </h2>
          {loadingTrainerLogs ? (
            <div className="flex justify-center py-8">
              <CircularProgress size={28} />
            </div>
          ) : (
            <TrainerMemberLogTable logs={trainerLogs} />
          )}
        </div>
      </Tooltip>
    </div>
  
</CustomModal>

      {
        isPopupOpen && (
            <Popup 
             onClose={() => setIsPopupOpen(false)}
             alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
             message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
             />
                
        )
      }
      
      <CustomModal isModal={isDeleteModalOpen} handleModal={toggleDeleteModal} size='md'>
        <div className='m-5'>
            <h2 className="text-xl font-medium">Delete Trainer?</h2>
            <p className="text-gx-ink-soft mt-3">Are you sure you want to delete this Trainer?</p>
            <button className={`bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`} onClick={deleteTrainer} disabled={buttonLoading}>
              {buttonLoading ? "Deleting..." : "Delete"}
              {buttonLoading && (
                <CircularProgress
                  size={20}
                  className="ml-2 mt-1"
                  sx={{ color: "white" }}
                />
              )}
            </button>
        </div>
      </CustomModal>

      <CustomModal isModal={isMemberModalOpen} handleModal={toggleMemberModal} size='xl'>
    <div className='m-5'>

      {
        loadingMembers ? (
          <div className="flex justify-center items-center mt-20 relative">
            {/* SVG Gradient Definition */}
            <svg width="0" height="0">
              <defs>
                <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#D71920" />
                  <stop offset="100%" stopColor="#F7931E" />
                </linearGradient>
              </defs>
            </svg>
    
            {/* Circular Progress with Gradient Stroke */}
            <CircularProgress
              thickness={4}
              size={35}
              sx={{
                'svg circle': {
                  stroke: 'url(#gradientColors)', // Apply gradient stroke
                },
              }}
            />
          </div>
        ) : (
          <>
            <h2 className="text-xl font-medium mb-5">
              Members — {trainer?.name ?? ''}
            </h2>
            <h3 className="text-md font-medium mb-3 text-gx-ink-soft">
              Currently assigned (active)
            </h3>
            {filteredMembers.length > 0 ? (
                <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx animate-fadeIn overflow-auto mb-6">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Member ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Phone</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredMembers.map((member) => (
                                <TableRow hover key={member._id}>
                                    <TableCell>{member.member_id}</TableCell>
                                    <TableCell>{member.name}</TableCell>
                                    <TableCell>{member.phone}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            ) : (
                <p className="text-gx-ink-soft mt-3 mb-6">No members currently assigned to this trainer.</p>
            )}
            <h3 className="text-md font-medium mb-3 text-gx-ink-soft">
              All assignment history (each period is a separate row)
            </h3>
            <TrainerMemberLogTable logs={trainerLogs} loading={loadingTrainerLogs} />
          </>
        )
      }
    </div>
</CustomModal>
      <PersonalTrainerStatsModal
        totalTrainers={totalTrainers}
        totalMembersCount={totalMembersCount}
        totalFees={totalFees}
        open={isStatsModalOpen}
        setOpen={setIsStatsModalOpen}
      />
    </>
  )
}

export default PersonalTrainers